import React from "react";
import Question from "../Question/question";
import "./TheoryContainer.scss";
const TheoryContainer = () => {
  return (
    <div className="content-border-box w-100">
      <Question type="theory" />
    </div>
  );
};

export default TheoryContainer;
